import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.total > _ctx.perPage)
      ? (_openBlock(), _createBlock(_component_Pagination, {
          key: 0,
          modelValue: _ctx.innerPage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerPage) = $event)),
          records: _ctx.total,
          "per-page": _ctx.perPage,
          onPaginate: _ctx.emitChange
        }, null, 8, ["modelValue", "records", "per-page", "onPaginate"]))
      : _createCommentVNode("", true)
  ]))
}